// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_BfFjk {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.CreateNotePopup_fL0rf {
  position: fixed;
  top: 50%;
  left: 50%;
  border-radius: 8px;
  background-color: var(--f5-background);
  z-index: 99;
  width: fit-content;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  -moz-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  -o-transform: translate(-50%, -50%) scale(1);
  animation: scaleUp_XuosH 300ms ease-out forwards;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  @media (width<768px) {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
}
.containerCreateNotepopup_dIgE6 {
  padding: 10px 23px;
}
.contentCreateNotePopup_gT_Ay {
  background-color: var(--white-color);
  box-sizing: border-box;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 10px;
}
.button_od1sx {
  text-decoration: underline;
  color: var(--_2-color);
  font-weight: 500;
  cursor: pointer;
  padding: 10px 23px;
}

.scaleDown_Wo6UK {
  animation: scaleDown_Wo6UK 300ms ease-in forwards;
  -webkit-animation: scaleDown_Wo6UK 300ms ease-in forwards;
}

@keyframes scaleUp_XuosH {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_Wo6UK {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_I7tZq {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CreateNotePopup/CreateNotePopup.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,iDAAiD;EACjD,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,gDAA0C;EAC1C,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".bg {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99;\n}\n\n.CreateNotePopup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  border-radius: 8px;\n  background-color: var(--f5-background);\n  z-index: 99;\n  width: fit-content;\n  transform: translate(-50%, -50%) scale(1);\n  -webkit-transform: translate(-50%, -50%) scale(1);\n  -moz-transform: translate(-50%, -50%) scale(1);\n  -ms-transform: translate(-50%, -50%) scale(1);\n  -o-transform: translate(-50%, -50%) scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  @media (width<768px) {\n    height: 100vh;\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n.containerCreateNotepopup {\n  padding: 10px 23px;\n}\n.contentCreateNotePopup {\n  background-color: var(--white-color);\n  box-sizing: border-box;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  padding: 10px;\n}\n.button {\n  text-decoration: underline;\n  color: var(--_2-color);\n  font-weight: 500;\n  cursor: pointer;\n  padding: 10px 23px;\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_BfFjk`,
	"CreateNotePopup": `CreateNotePopup_fL0rf`,
	"scaleUp": `scaleUp_XuosH`,
	"containerCreateNotepopup": `containerCreateNotepopup_dIgE6`,
	"contentCreateNotePopup": `contentCreateNotePopup_gT_Ay`,
	"button": `button_od1sx`,
	"scaleDown": `scaleDown_Wo6UK`,
	"fadeOut": `fadeOut_I7tZq`
};
export default ___CSS_LOADER_EXPORT___;
